export default __webpack_public_path__ + "static/media/tea-berry.a1e2be60.png";